import React, { useEffect } from "react";
import AboutContent from "../components/about/AboutContent";
import Vision from "../components/about/Vision";
import TeamList from "../components/team/TeamList";
import ContactCTA from "../components/home/ContactCTA";

const AboutPage = () => {
  useEffect(() => {
    document.title = "About Us | Professional Service Associates";
  }, []);

  return (
    <>
      <div className="bg-psa-green-600 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center font-display">
            About Us
          </h1>
        </div>
      </div>
      <AboutContent />
      <Vision />
      <TeamList />
      <ContactCTA />
    </>
  );
};

export default AboutPage;
